// extracted by mini-css-extract-plugin
export default {"info":"MapLegend_info__aWNaY","unitText":"MapLegend_unitText__W8KBA","legend":"MapLegend_legend__4J9Fo"};